import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { RegisterEmployeeService } from '@app/_services/register.Employee.service';
import { RegisterEmployee } from '@app/_models/registerEmployee';
import { Observable, of } from 'rxjs';
import { NgxSpinnerService } from "ngx-spinner";
import { NgbModalConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-register-employer',
  templateUrl: './register-employer.component.html',
  styleUrls: ['./register-employer.component.css']
})
export class RegisterEmployerComponent implements OnInit {
  recaptchaSiteKey = environment.recaptchaSiteKey;
  emailPattern ="^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$";// "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  PANNoPattern = "[A-Z]{5}[0-9]{4}[A-Z]{1}";
  JSTNumber="^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$";//"^[A-Za-z0-9]+$";//"/[a-zA-Z]{3}[PCHFATBLJG]{1}[a-zA-Z]{1}[0-9]{4}[a-zA-Z]{1}$/";
  // /06ghhtn6385r6g2
  submitted = false;
  returnUrl;
  invalidCaptcha: string;
  showModalBox: boolean = false;
  registerEmployeeForm: FormGroup;
  RegisterEmployee = new RegisterEmployee();
  getresponse: any;
  submitMessage: string;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;


  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.invalidCaptcha = "";
  }


  form: FormGroup;

  constructor(private formBuilder: FormBuilder, private router: Router,
    private registerEmployeeService: RegisterEmployeeService,
    public fb: FormBuilder,
    private SpinnerService: NgxSpinnerService,
    config: NgbModalConfig,
    private modalService: NgbModal
  ) {
    // customize default values of modals used by this component tree
    config.backdrop = 'static';
    config.keyboard = false;

    this.form = this.fb.group({
      firstName: [''],
      lastName: [''],
      companyName: [''],
      emailId: [''],
     // contactPersonName: [''],
     phoneNumber: [''],
      password: [''],
      rePassword: [''],
      gstNo: [''],
      panNumber: [''],
      areYouGov: [''],
      gstExemption: [''],
      pincode: [''],
      city: [''],
      state: [''],
      country: [''],
      address: ['']
    })

  }

  get f() { return this.registerEmployeeForm.controls; }

  //only number will be add
  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  
  ngOnInit() {
    
    this.registerEmployeeForm = this.formBuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      companyName: ['', Validators.required],
      emailId: ['', Validators.required],
     // contactPersonName: ['', Validators.required],
      password: ['', Validators.required],
      rePassword: ['', Validators.required],
      phoneNumber: ['', [Validators.required, Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]],
      roleId: ['2'],
      gstNo: ['', Validators.required],
      panNumber: ['', Validators.required],
      areYouGov: ['', Validators.required],
      gstExemption: [{value: '', disabled: true}],
      pincode: ['', Validators.required],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', Validators.required],
      address: ['', Validators.required],
      cb: [false, Validators.requiredTrue]
    });
  }
  
//  gstExemptionDisabled = true
  ngAfterViewInit() {
    this.RegisterEmployee.gstExemption = "N"
    this.RegisterEmployee.areYouGov = "N"
  }

  
  
  gstExemptionChange(val) { 
    console.log("inpVal = ", val);
    if (val === 'N') {
      console.log("inpVal44 = ", val);
   //   this.gstExemptionDisabled = false;
    this.registerEmployeeForm.controls['gstNo'].setValidators([Validators.required, Validators.pattern(this.JSTNumber)]);
    this.registerEmployeeForm.controls['gstNo'].updateValueAndValidity();
    this.registerEmployeeForm.controls['panNumber'].setValidators([Validators.required, Validators.pattern(this.PANNoPattern)]);
    this.registerEmployeeForm.controls['panNumber'].updateValueAndValidity();
    } else {
    //  this.gstExemptionDisabled = true;
      this.registerEmployeeForm.controls['gstNo'].clearValidators();
      this.registerEmployeeForm.controls['gstNo'].updateValueAndValidity();
      this.registerEmployeeForm.controls['panNumber'].clearValidators();
      this.registerEmployeeForm.controls['panNumber'].updateValueAndValidity();
    }
  }
  

  areYouGovChange(inpVal) {
    console.log("inpVal = ", inpVal);
    const gstExemptionValue = this.RegisterEmployee.gstExemption;
    console.log("gstExemptionValue = ", gstExemptionValue);
    if (inpVal === "Y") {
    //  this.gstExemptionDisabled = false;
      this.registerEmployeeForm.controls.gstExemption.enable();
      if(gstExemptionValue === "Y"){
        console.log("gstExemptionValue = ", gstExemptionValue);
    //    console.log("gstExemptionDisabled = ", this.gstExemptionDisabled);
        console.log("Clearing validators for gstNo and panNumber");
        this.registerEmployeeForm.controls['gstNo'].clearValidators();
        this.registerEmployeeForm.controls['gstNo'].updateValueAndValidity();
        this.registerEmployeeForm.controls['panNumber'].clearValidators();
        this.registerEmployeeForm.controls['panNumber'].updateValueAndValidity();
      }    
      } else {
   //   console.log("gstExemptionDisabled = ", this.gstExemptionDisabled);
     // this.gstExemptionDisabled = true;
      this.registerEmployeeForm.controls.gstExemption.disable();
      this.registerEmployeeForm.controls['gstNo'].setValidators([Validators.required, Validators.pattern(this.JSTNumber)]);
      this.registerEmployeeForm.controls['gstNo'].updateValueAndValidity();
      this.registerEmployeeForm.controls['panNumber'].setValidators([Validators.required, Validators.pattern(this.PANNoPattern)]);
      this.registerEmployeeForm.controls['panNumber'].updateValueAndValidity();
    }
  }
  refresh(): void {
    location.reload();
  }
  submitForm1() {
    this.registerEmployeeService.addRegister(this.RegisterEmployee).subscribe(
      (resp) => {
        console.log(resp);
        alert(resp);
      },
      (error) => {
        console.log(error.error);
        alert(error.error);
      }
    );

    this.registerEmployeeService.addRegister(this.RegisterEmployee)
      .pipe(map((res: Response) => res.json()))
      .subscribe(
        data => {
          alert('Registration successful');
          this.router.navigate(['/login']);
        },
        (error: HttpErrorResponse) => {
          let errorPayload = JSON.parse(error.message);
          //ToDo: apply your handling logic e.g.:
          //console.log(errorPayload[0].description
          console.log(error.error);
        });


  }
  submitForm() {
    //this.modalService.open(this.showModalBoxTemplate);
    //this.modalService.open(this.showModalBoxTemplate);
    console.log(this.form.value)

    this.submitted = true;
    var res = $('#g-recaptcha-response').val();
    // stop here if form is invalid
    if (this.registerEmployeeForm.invalid) {
      this.showModalBox = false;
      if (res == "") {
        this.invalidCaptcha = "Please click on recaptcha";
        return;
      }
      else {
        if (this.registerEmployeeForm.invalid) { this.showModalBox = false; return; }
        this.invalidCaptcha = "";
      }
    }

    if (res == "") {
      this.invalidCaptcha = "Please click on recaptcha";
      return;
    }
    this.registerEmployeeService.addRegister(this.RegisterEmployee)
      .subscribe((response) => {
        if (response) {
          this.getresponse = response;
          //this.invalidCaptcha = "Email is sent to you for verification. Please verify your mail.";
          if (this.getresponse.respMessage == "Success") {
            this.SpinnerService.hide();
            // this.showModalBox = true;
            this.modalService.open(this.showModalBoxTemplate);
            //alert("Email is sent to you for verification. Please verify your mail.");
            //location.reload();
            // this.returnUrl = "login";
            // this.router.navigate([this.returnUrl]);
          }
          else {
            this.SpinnerService.hide();
            this.submitMessage = this.getresponse.respData;
          }
        }
        else {
          this.SpinnerService.hide();
        }
      },
        (err: any) => {
          this.SpinnerService.hide();
          var message = err;
          this.showModalBox = false;
          this.invalidCaptcha = "Invalid";
          // alert("Error Message"+ err);
        });
    this.SpinnerService.show();

    this.invalidCaptcha = "";
    this.submitMessage = "";
    // this.returnUrl = "login";
    // this.router.navigate([this.returnUrl]);
  }

}
